let zhaopin = [
	//1
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 440303,
		contactPerson: "黎经伟",
		contactTel: "18924944931",
		createTime: "2021-07-07",
		districtCode: 4403,
		education: "不限",
		faceToFace: 1,
		id: 34,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "http://image.hudiejx.com/recruit/20210707/d9ea8a68a03943a0a48908944e6e0509.jpeg",
		provinceCode: 44,
		recruitNum: 100,
		remark: "专业办理所有工程机械操作证，合格证，铭牌，尾气报告，年检报告，环保二维码",
		salaryMax: 20000,
		salaryMin: 20000,
		sex: "男",
		sort: 0,
		status: 0,
		title: "办证",
		updateTime: "2021-07-07 15:04:43",
		userId: 4483,
		welfares: "五险,公积金,包吃,包住,周末双休,带薪年假,交通补助,通讯补助,年底双薪,绩效奖金,白班,餐补,免费班车,年度旅游",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "广东省深圳市罗湖区",
		workTime: "面议",
	},
	//2
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 178,
		brandName: null,
		cityCode: 431302,
		contactPerson: "盛",
		contactTel: "18845673288",
		createTime: "2021-06-10",
		districtCode: 4313,
		education: "不限",
		faceToFace: 1,
		id: 33,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 43,
		recruitNum: 1,
		remark: "下过跟进护筒优先",
		salaryMax: 12000,
		salaryMin: 10000,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "招聘旋挖钻机机手",
		updateTime: "2021-06-10 10:05:46",
		userId: 4365,
		welfares: "包吃,包住",
		workExperienceCode: 3,
		workExperienceStr: "3年及以上",
		workPlace: "湖南省娄底市娄星区",
		workTime: "白班",
	},
	//3
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 371002,
		contactPerson: "宋",
		contactTel: "13625878818",
		createTime: "2021-06-10",
		districtCode: 3710,
		education: "不限",
		faceToFace: 0,
		id: 32,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 37,
		recruitNum: 1,
		remark: "徐工280有房建经验即可",
		salaryMax: null,
		salaryMin: null,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "招聘旋挖钻机操作手",
		updateTime: "2021-06-10 10:05:49",
		userId: 4365,
		welfares: "包吃,包住",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "山东省威海市环翠区",
		workTime: "面议",
	},
	//4
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 460203,
		contactPerson: "李",
		contactTel: "13623451940",
		createTime: "2021-06-10",
		districtCode: 4602,
		education: "不限",
		faceToFace: 0,
		id: 31,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "http://image.hudiejx.com/recruit/20210610/55e18892ff7c455588eea8b7ac0fde2b.jpeg",
		provinceCode: 46,
		recruitNum: 1,
		remark: "三亚招一名旋挖机学徒，工地上1对1教学，包教包会，欢迎来电",
		salaryMax: null,
		salaryMin: null,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖钻机操作手/司机",
		updateTime: "2021-06-10 10:05:53",
		userId: 4365,
		welfares: "包吃,包住",
		workExperienceCode: 1,
		workExperienceStr: "1年及以上",
		workPlace: "海南省三亚市吉阳区",
		workTime: "面议",
	},
	//5
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 430105,
		contactPerson: "刘",
		contactTel: "18942344589",
		createTime: "2021-06-09",
		districtCode: 4301,
		education: "高中",
		faceToFace: 1,
		id: 30,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 43,
		recruitNum: 10,
		remark: "",
		salaryMax: 7000,
		salaryMin: 4000,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖钻机机手",
		updateTime: "2021-06-09 16:35:36",
		userId: 4365,
		welfares: "包吃,包住,交通补助,通讯补助",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "湖南省长沙市开福区",
		workTime: "面议",
	},
	//6
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 330102,
		contactPerson: "沈经理",
		contactTel: "13967101208",
		createTime: "2021-06-09",
		districtCode: 3301,
		education: "不限",
		faceToFace: 1,
		id: 29,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 33,
		recruitNum: 20,
		remark: "杭州神宇路桥工程有限公司",
		salaryMax: 10000,
		salaryMin: 5000,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖钻机司机",
		updateTime: "2021-06-09 16:35:39",
		userId: 4365,
		welfares: "包吃,包住,交通补助,白班",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "浙江省杭州市上城区",
		workTime: "白班",
	},
	//7
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 360902,
		contactPerson: "蒋",
		contactTel: "18823249140",
		createTime: "2021-06-08",
		districtCode: 3609,
		education: "不限",
		faceToFace: 0,
		id: 28,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 36,
		recruitNum: 1,
		remark: "",
		salaryMax: null,
		salaryMin: null,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖钻机学徒工",
		updateTime: "2021-06-08 17:09:04",
		userId: 4365,
		welfares: "包吃,包住",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "江西省宜春市袁州区",
		workTime: "白班",
	},
	//8
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 177,
		brandName: null,
		cityCode: 440605,
		contactPerson: "冉",
		contactTel: "17723466890",
		createTime: "2021-06-08",
		districtCode: 4406,
		education: "不限",
		faceToFace: 1,
		id: 27,
		isOwn: null,
		machineId: 4,
		machineName: null,
		pictures: "",
		provinceCode: 44,
		recruitNum: 1,
		remark: "",
		salaryMax: 7000,
		salaryMin: 6000,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "挖掘机修理工",
		updateTime: "2021-06-09 11:28:09",
		userId: 4365,
		welfares: "包吃,包住,交通补助,白班,餐补",
		workExperienceCode: 3,
		workExperienceStr: "3年及以上",
		workPlace: "广东省佛山市南海区",
		workTime: "白班",
	},
	//9
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 211,
		brandName: null,
		cityCode: 620171,
		contactPerson: "高",
		contactTel: "13956778369",
		createTime: "2021-06-08",
		districtCode: 6201,
		education: "不限",
		faceToFace: 0,
		id: 26,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 62,
		recruitNum: 3,
		remark: "",
		salaryMax: null,
		salaryMin: null,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖机手",
		updateTime: "2021-06-09 11:28:05",
		userId: 4365,
		welfares: "包吃,包住,交通补助",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "甘肃省兰州市兰州新区",
		workTime: "白班",
	},
	//10
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 174,
		brandName: null,
		cityCode: 440112,
		contactPerson: "朱",
		contactTel: "15023242319",
		createTime: "2021-06-08",
		districtCode: 4401,
		education: "不限",
		faceToFace: 1,
		id: 25,
		isOwn: null,
		machineId: 3,
		machineName: null,
		pictures: "",
		provinceCode: 44,
		recruitNum: 2,
		remark: "",
		salaryMax: 8000,
		salaryMin: 8000,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "旋挖机手",
		updateTime: "2021-06-08 17:09:07",
		userId: 4365,
		welfares: "包吃,包住",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "广东省广州市黄埔区",
		workTime: "面议",
	},
	//11
	{
		ageMax: 0,
		ageMin: 0,
		brandId: 178,
		brandName: null,
		cityCode: 340403,
		contactPerson: "刘",
		contactTel: "15347785699",
		createTime: "2021-06-08",
		districtCode: 3404,
		education: "不限",
		faceToFace: 0,
		id: 24,
		isOwn: null,
		machineId: 4,
		machineName: null,
		pictures: "",
		provinceCode: 34,
		recruitNum: 5,
		remark: "",
		salaryMax: null,
		salaryMin: null,
		sex: "不限",
		sort: 0,
		status: 1,
		title: "维修挖机机手",
		updateTime: "2021-06-09 11:28:02",
		userId: 4365,
		welfares: "包吃,包住,交通补助,通讯补助",
		workExperienceCode: 0,
		workExperienceStr: "不限",
		workPlace: "安徽省淮南市田家庵区",
		workTime: "白班",
	},
]

module.exports = {
	zhaopin: zhaopin
}